import { render, staticRenderFns } from "./pdfTemplateEdit.vue?vue&type=template&id=5fb4de31&"
import script from "./pdfTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./pdfTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports